import React, {useContext, useState} from 'react';
import AuthContext from "../context/AuthProvider";
import {Link, Navigate} from "react-router";
import {Helmet} from "react-helmet";
import LogoutButton from "./LogoutButton";
import FraudioLoader from "./FraudioLoader";

const KIRMIZI = "#EB0A1E";

const kartStyle = {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.10)",
    borderRadius: "16px",
    padding: "28px 32px",
    marginBottom: "24px",
};

const kartBaslikStyle = {
    display: "flex",
    alignItems: "flex-start",
    gap: "18px",
    marginBottom: "20px",
};

const rozetStyle = {
    background: KIRMIZI,
    color: "#fff",
    fontWeight: 800,
    fontSize: "12px",
    letterSpacing: "1.5px",
    padding: "7px 16px",
    borderRadius: "20px",
    whiteSpace: "nowrap",
    flexShrink: 0,
    marginTop: "3px",
};

const kartAdiStyle = {
    color: "#fff",
    fontWeight: 700,
    fontSize: "18px",
    marginBottom: "5px",
    letterSpacing: "0.4px",
};

const kartAciklamaStyle = {
    color: "rgba(255,255,255,0.5)",
    fontSize: "13px",
    margin: 0,
    lineHeight: 1.6,
};

const SINYALLER = [
    {ikon: "📍", ad: "Şehir", kaynak: "Dinleyicinin IP'sinden tespit edilir"},
    {ikon: "🌦️", ad: "Hava koşulu", kaynak: "Anlık sıcaklık, yağış ve rüzgâr"},
    {ikon: "🚗", ad: "Trafik yoğunluğu", kaynak: "Bulunduğu noktadaki anlık akış hızı"},
    {ikon: "🕐", ad: "Günün saati", kaynak: "Sabah, öğle, akşam, gece"},
    {ikon: "🏢", ad: "Bayi yakınlığı", kaynak: "En yakın Toyota noktası ve mesafesi"},
];

function Toyota() {
    const { auth } = useContext(AuthContext);

    // Her ziyarette o anın koşullarıyla üretilmiş sesi al (tarayıcı önbelleğini atla)
    const [zaman] = useState(() => Date.now());

    if (auth !== "toyota@audiotime.com.tr") {
        return <Navigate to="/giris" />;
    }

    return (
        <React.Fragment>
            <Helmet>
                <script src={`${process.env.PUBLIC_URL}/assets/js/fraudio.min.js`} type="text/javascript"/>
                <link rel="stylesheet" href={`${process.env.PUBLIC_URL}/assets/css/fraudio.css`}/>
            </Helmet>

            {/* ── HERO ── */}
            <div style={{
                background: "linear-gradient(120deg, #0b0b0d 0%, #14161a 55%, #1b1013 100%)",
                position: "relative",
                minHeight: "420px",
                display: "flex",
                alignItems: "center",
                padding: "140px 0 60px",
                overflow: "hidden",
            }}>
                <div style={{
                    position: "absolute",
                    top: "-140px",
                    right: "-120px",
                    width: "520px",
                    height: "520px",
                    borderRadius: "50%",
                    background: `radial-gradient(circle, ${KIRMIZI}22 0%, transparent 68%)`,
                }} />

                <div className="container" style={{position: "relative", zIndex: 1}}>
                    <div className="row">
                        <div className="col-lg-8 col-md-10">

                            <h1 style={{
                                color: "#fff",
                                fontSize: "clamp(30px, 4.5vw, 58px)",
                                fontWeight: 900,
                                letterSpacing: "2px",
                                textTransform: "uppercase",
                                lineHeight: 1.1,
                                marginBottom: "8px",
                            }}>
                                TOYOTA <span style={{color: KIRMIZI}}>RAV4</span>
                            </h1>
                            <h2 style={{
                                color: "rgba(255,255,255,0.7)",
                                fontSize: "clamp(13px, 1.8vw, 18px)",
                                fontWeight: 400,
                                letterSpacing: "5px",
                                textTransform: "uppercase",
                                marginBottom: "20px",
                            }}>
                                YAPAY ZEKA DEMO
                            </h2>

                            <div style={{
                                width: "60px",
                                height: "2px",
                                background: `linear-gradient(to right, ${KIRMIZI}, transparent)`,
                                marginBottom: "22px",
                            }} />

                            <p style={{
                                color: "rgba(255,255,255,0.6)",
                                fontSize: "16px",
                                lineHeight: 1.7,
                                maxWidth: "520px",
                                marginBottom: "28px",
                            }}>
                                Koşullar değişir, RAV4 uyumlanır. Sabit bir reklam mesajı yerine;
                                sürücünün bulunduğu şehre, hava koşullarına, trafik yoğunluğuna,
                                günün saatine ve en yakın Toyota noktasına göre anlık olarak
                                uyarlanan dinamik bir ses projesi.
                            </p>

                            <div style={{display: "flex", alignItems: "center", gap: "24px", flexWrap: "wrap"}}>
                                <ul className="breadcumb__list" style={{margin: 0}}>
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            <i className="las la-home"/> Ana Sayfa
                                        </Link>
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">TOYOTA RAV4</li>
                                </ul>
                                <LogoutButton />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* ── SİNYALLER ── */}
            <div style={{background: "#0b0b0d", borderTop: "1px solid rgba(255,255,255,0.06)", padding: "60px 0 20px"}}>
                <div className="container">
                    <p style={{
                        color: KIRMIZI,
                        fontSize: "11px",
                        letterSpacing: "4px",
                        textTransform: "uppercase",
                        marginBottom: "12px",
                    }}>Reklamı Şekillendiren Veriler</p>
                    <h3 style={{color: "#fff", fontSize: "24px", fontWeight: 700, marginBottom: "36px"}}>
                        Clerk, açık kaynaklardan aldığı verileri analiz eder
                    </h3>

                    <div className="row g-3">
                        {SINYALLER.map(s => (
                            <div className="col-lg col-md-4 col-6" key={s.ad}>
                                <div style={{
                                    background: "rgba(255,255,255,0.04)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                    borderRadius: "12px",
                                    padding: "20px 18px",
                                    height: "100%",
                                }}>
                                    <div style={{fontSize: "22px", marginBottom: "10px"}}>{s.ikon}</div>
                                    <div style={{color: "#fff", fontSize: "14px", fontWeight: 700, marginBottom: "6px"}}>
                                        {s.ad}
                                    </div>
                                    <div style={{color: "rgba(255,255,255,0.42)", fontSize: "12px", lineHeight: 1.5}}>
                                        {s.kaynak}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── OYNATICILAR ── */}
            <div style={{background: "linear-gradient(180deg, #0b0b0d 0%, #131417 100%)", padding: "60px 0 90px"}}>
                <div className="container">

                    <div className="row justify-content-center" style={{marginBottom: "40px"}}>
                        <div className="col-lg-8 col-md-10 text-center">
                            <p style={{
                                color: KIRMIZI,
                                fontSize: "11px",
                                letterSpacing: "4px",
                                textTransform: "uppercase",
                                marginBottom: "8px",
                            }}>Demo Ses Reklamları</p>
                            <h3 style={{color: "#fff", fontSize: "24px", fontWeight: 700, margin: 0}}>
                                2 Farklı Senaryo
                            </h3>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10">

                            {/* Senaryo 1 */}
                            <div style={kartStyle}>
                                <div style={kartBaslikStyle}>
                                    <span style={rozetStyle}>🌦️ 01</span>
                                    <div>
                                        <h4 style={kartAdiStyle}>KOŞUL UYUMU</h4>
                                        <p style={kartAciklamaStyle}>
                                            Bulunduğunuz şehrin anlık hava durumu ve günün saatine göre üretilir.
                                            Yağmurda dört çeker, siste sürüş destek sistemleri, açık havada hibrit
                                            verimlilik öne çıkar.
                                        </p>
                                    </div>
                                </div>
                                <FraudioLoader
                                    src={`https://audiotime.clerkai.app/toyota1.php?t=${zaman}`}
                                    title="Koşul Uyumu"
                                    artist="Toyota RAV4 Yapay Zeka"
                                />
                            </div>

                            {/* Senaryo 2 */}
                            <div style={kartStyle}>
                                <div style={kartBaslikStyle}>
                                    <span style={rozetStyle}>🚗 02</span>
                                    <div>
                                        <h4 style={kartAdiStyle}>TRAFİK & EN YAKIN TOYOTA</h4>
                                        <p style={kartAciklamaStyle}>
                                            Bulunduğunuz noktadaki anlık trafik akışına göre üretilir. Yoğun
                                            trafikte RAV4 Hybrid'in tasarrufu anlatılır, ardından size en yakın
                                            Toyota noktası ve mesafesi söylenir.
                                        </p>
                                    </div>
                                </div>
                                <FraudioLoader
                                    src={`https://audiotime.clerkai.app/toyota2.php?t=${zaman}`}
                                    title="Trafik & En Yakın Toyota"
                                    artist="Toyota RAV4 Yapay Zeka"
                                />
                            </div>

                            <p style={{
                                color: "rgba(255,255,255,0.35)",
                                fontSize: "12px",
                                textAlign: "center",
                                marginTop: "28px",
                                marginBottom: 0,
                                lineHeight: 1.7,
                            }}>
                                Sesler önceden kaydedilmiş değildir; her dinleyici için o anki koşullara göre
                                üretilir. Farklı bir şehirden veya farklı bir saatte dinlediğinizde metin değişir.
                            </p>

                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
}

export default Toyota;
